import { setLocale } from 'web-app/util/locale';
export const supportedLanguages = [
    'da_DK',
    'en_US',
    'en_GB',
    'de_DE',
    'no_NO',
    'es_ES',
    'es_US',
    'nl_NL',
];
export const defaultLocale = 'en_US';
const makeLocaleSetup = (getLocaleFromApi, savedLocale) => () => {
    return new Promise(resolve => {
        if (savedLocale) {
            if (supportedLanguages.includes(savedLocale)) {
                resolve(savedLocale);
            }
            else {
                // tslint:disable-next-line:no-console
                console.warn(`Failed to load unknown locale ${savedLocale} from localstorage. Defaulting to ${defaultLocale}`);
                resolve(defaultLocale);
            }
        }
        else if (!navigator.onLine) {
            resolve(defaultLocale);
        }
        else {
            let alreadyResolved = false;
            getLocaleFromApi().then(data => {
                if (!alreadyResolved) {
                    alreadyResolved = true;
                    resolve(data.locale);
                }
            }, () => {
                if (!alreadyResolved) {
                    alreadyResolved = true;
                    resolve(defaultLocale);
                }
            });
            setTimeout(() => {
                if (!alreadyResolved) {
                    alreadyResolved = true;
                    resolve(defaultLocale);
                }
            }, 4000);
        }
    }).then(locale => {
        return setLocale(locale);
    });
};
export default makeLocaleSetup;
